import { INode, resolve } from "aurelia";
import { I18N } from "@aurelia/i18n";
import { IRouter } from "@aurelia/router";
import { bindable } from "@aurelia/runtime-html";
import { fromState, IStore } from "@aurelia/state";

import { GlobalHelper } from "@/shared/shared";
import { IModule, IVessel } from "@/shared/user";
import {
  TOGGLE_SIDEBAR,
  TOGGLE_SIDEBAR_ORDER,
  ToggleSidebarOrderAction,
} from "@/static/storeActions";
import { IState } from "@/store/state";

declare const VERSION: string;
declare const HASH: string;

export class MtSidebar {
  private version: string;
  private hash: string;

  @bindable isSidebarOpen: boolean;

  // State bindings
  @fromState((state: IState) => !state.user.details.email.includes("petrobras"))
  isApproved: boolean;
  @fromState((state: IState) => state.isLoggedIn)
  isLoggedIn: boolean;
  @fromState((state: IState) =>
    state.user.details.email.includes("petrobras") ? false : state.settings.isSidebarByVessel
  )
  isSidebarByVessel: boolean;
  @fromState((state: IState) => state.settings.isDarkThemeOn)
  isDarkThemeOn: boolean;
  @fromState((state: IState) => state.user.assets.vessels)
  private vessels: IVessel[];
  @fromState((state: IState) => state.user.assets.modules)
  private modules: IModule[];

  private readonly store = resolve(IStore) as IStore<IState, ToggleSidebarOrderAction>;

  private element = resolve(INode) as HTMLElement;
  private router: IRouter = resolve(IRouter);
  private i18n: I18N = resolve(I18N);

  constructor() {
    this.updateLocale();
    this.i18n.subscribeLocaleChange({
      handleLocaleChange: () => this.updateLocale(),
    });

    this.version = VERSION;
    this.hash = HASH.substring(0, 8);
    console.log(`${VERSION}-${HASH}`);
  }

  toggleOrder = () => {
    this.store.dispatch({ type: TOGGLE_SIDEBAR_ORDER });
  };

  private buttons: Array<{ label: string; id: string }> = [];

  sortVessels(vessels: IVessel[]) {
    return vessels.sort((entryA, entryB) => entryA.name.localeCompare(entryB.name));
  }

  updateLocale() {
    this.buttons = [
      { label: this.i18n.tr("other.vessels"), id: "vessels-sidebar-button" },
      { label: this.i18n.tr("other.modules"), id: "modules-sidebar-button" },
    ];
  }

  sortAndFilterVesselModules(modules: IModule[]) {
    GlobalHelper.addModuleNames(modules);
    return GlobalHelper.sortAndFilterModules(modules, [0, 8, 18, 19]); // exclude Vessel Info module and whatever module 18 is
  }

  sortAndFilterModules(modules: IModule[]) {
    return GlobalHelper.sortAndFilterModules(modules, [0, 8, 16]); // exclude Landing and Vessel Info module
  }

  private routeTo(url: string, vesselIds: string, alphaId: string) {
    if (url.startsWith("http") || url.startsWith("https")) {
      window.open(url, "_blank");
      return;
    }

    if (!vesselIds) this.router.load(url);
    else this.router.load(url, { parameters: { vesselIds, alphaId } });

    // Auto-close sidebar on mobile after navigation
    if (window.innerWidth < 768) {
      this.store.dispatch({ type: TOGGLE_SIDEBAR });
    }
  }

  private getIconById(id: number) {
    return GlobalHelper.getIconById(id);
  }

  private getModuleNameById(id: number) {
    return GlobalHelper.getModuleNameById(id);
  }

  private getRouteById(id: number) {
    return GlobalHelper.getRouteById(id);
  }
}
